// create a container and set the full-size image as its background
// Mischief Mates (2026-10-10): the magnifier opens as soon as the cursor is over the photo on a
// desktop (no click needed), and it loads a larger copy of the photo so the Mates stay sharp.
const MM_ZOOM_WIDTH = 2400;
let overlay = null;
let pointer = null;
// A click closes the magnifier; it stays closed until the cursor leaves the photo and comes back.
let dismissed = false;

function zoomSource(image) {
  const src = image.currentSrc || image.src;
  return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, `$1${MM_ZOOM_WIDTH}`) : src;
}

function canHoverZoom() {
  return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)').matches;
}

function createOverlay(image, zoomRatio, hovered) {
  const source = zoomSource(image);
  const overlayImage = document.createElement('img');
  const pending = document.createElement('div');
  overlay = pending;
  prepareOverlay(pending, source);

  // Hover opens quietly: no dimming or spinner flash while the larger photo loads.
  if (!hovered) {
    image.style.opacity = '50%';
    toggleLoadingSpinner(image);
  }

  overlayImage.onload = () => {
    if (!hovered) {
      toggleLoadingSpinner(image);
      image.style.opacity = '100%';
    }
    // The cursor left (or another photo took over) before the larger photo arrived.
    if (overlay !== pending || (hovered && !image.matches(':hover'))) {
      if (overlay === pending) overlay = null;
      return;
    }
    image.parentElement.insertBefore(pending, image);
    if (pointer) moveWithHover(image, pointer, zoomRatio);
  };
  overlayImage.setAttribute('src', source);

  return pending;
}

function prepareOverlay(container, source) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${source}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  if (!overlay) return;
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = image.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function closeOverlay() {
  if (overlay) overlay.remove();
  overlay = null;
}

function magnify(image, zoomRatio, hovered) {
  closeOverlay();
  const current = createOverlay(image, zoomRatio, hovered);
  current.onclick = () => {
    dismissed = hovered;
    closeOverlay();
  };
  current.onmousemove = (event) => {
    pointer = event;
    moveWithHover(image, event, zoomRatio);
  };
  current.onmouseleave = closeOverlay;
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      pointer = event;
      magnify(image, zoomRatio, false);
      moveWithHover(image, event, zoomRatio);
    };
    image.onmouseenter = (event) => {
      if (!canHoverZoom() || dismissed) return;
      pointer = event;
      magnify(image, zoomRatio, true);
    };
    image.onmousemove = (event) => {
      pointer = event;
    };
    image.onmouseleave = () => {
      if (!overlay) dismissed = false;
    };
  });
}

enableZoomOnHover(2);
